import { createContext, useContext, useEffect, useState } from "react";

const KEY = "epplehub_theme";
const modes = ["light", "dark", "system"];
const ThemeContext = createContext(null);
const readMode = () => { try { return modes.includes(localStorage.getItem(KEY)) ? localStorage.getItem(KEY) : "light"; } catch { return "light"; } };

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(readMode);
  const [systemDark, setSystemDark] = useState(() => window.matchMedia("(prefers-color-scheme: dark)").matches);
  const theme = mode === "system" ? (systemDark ? "dark" : "light") : mode;
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const sync = () => setSystemDark(media.matches);
    const storage = event => { if (event.key === KEY || event.key === null) setMode(readMode()); };
    media.addEventListener("change", sync);
    window.addEventListener("storage", storage);
    return () => { media.removeEventListener("change", sync); window.removeEventListener("storage", storage); };
  }, []);
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "dark" ? "#0d1728" : "#f3f7ff");
  }, [theme]);
  const chooseMode = next => {
    if (!modes.includes(next)) return;
    try { localStorage.setItem(KEY, next); } catch { /* Session-only preference if storage is unavailable. */ }
    setMode(next);
  };
  return <ThemeContext.Provider value={{ mode, theme, setMode: chooseMode }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
